import axios from "axios";
import { Auth } from "./authService";
const { BACKEND_URL } = require("../config/config");

const authController = new Auth();

export function getAllPermisos() {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/permiso`;
  console.log(url);
  return axios.get(url, {
    headers: {
      Authorization: token,
    },
  });
}

